import axios from "@/api/axios"

class Device {
  constructor() {
    this.numpad = false
    this.deviceClass = "stb"
    this._nativeVolumeMax = null
  }
  async _init() {
    _$.vue.$on("bluetooth", () => this._checkRemoteState())
    window.setInterval(() => this._checkRemoteState(), 10000)
    return true
  }

  async properties() {
    //{ macAddress, ipAddress, serial, firmwareVersion, appVersion, brand, model }
    const { macAddress, ipAddress, serial, firmwareVersion, appVersion, fingerprintId, brand, manufacturer, model } = await __._api.getProperties()
    const modelLabel = `${model || ""}`.toLowerCase()
    const isTvLike = modelLabel.includes("tv") && !modelLabel.includes("box") && !modelLabel.includes("stb")
    this.deviceClass = isTvLike ? "tv" : "stb"

    let resolvedMac = fingerprintId || macAddress
    try {
      const identityEndpoint = `${location.origin}/Api/network/device_identity.php?fingerprintId=${encodeURIComponent(fingerprintId || "")}`
      const response = await fetch(identityEndpoint, { cache: "no-store" })
      if (response.ok) {
        const identity = await response.json()
        if (identity?.macAddress) {
          resolvedMac = identity.macAddress
        }
      }
    } catch (e) {
      // Keep local fallback when backend identity service is unavailable.
    }

    const properties = {
      mac: resolvedMac,
      ip: ipAddress,
      serial: serial || "000000",
      firmware: firmwareVersion,
      software: appVersion,
      fingerprint: fingerprintId,
      manufacturer: manufacturer || brand || "TCL",
      product: model || "Smart TV",
      deviceClass: this.deviceClass,
      type: "playmoregtv"
    }

    const res = Object.keys(properties).every(key => properties[key] || false)

    return res && properties
  }
  async baseUrl() {
    try {
      return JSON.parse(playmore.platform.getConfigAll("private")).url
    } catch (error) {
      return location.origin
    }
  }
  async getKeyMap() {
    return [
      // Controllers
      [21, "left"],
      [19, "up"],
      [22, "right"],
      [20, "down"],
      [23, "enter"],
      [4, "back"],
      [3, "exit"],
      [-1, "vol_up"],
      [-1, "vol_down"],
      [-1, "mute"],

      // Player Controller
      [-1, "play"],
      [-1, "pause"],
      [85, "toggle"],
      [-1, "stop"],
      [90, "fw"],
      [89, "rw"],
      [88, "prev"],
      [87, "next"],

      // TV
      //[92, "ch_up"],
      //[93, "ch_down"],
      [166, "ch_up"],
      [167, "ch_down"],
      [131, "tv"], //Register
      [-1, "subtitle"], //Register
      [-1, "list"], //Register
      [-1, "epg"],
      [136, "switch"],
      [133, "favorite"],

      // General
      [132, "info"],
      [186, "settings"], //Register
      [-1, "alarm-clock"],
      [-1, "sleep-timer"],
      [-1, "source"], //Register
      [-1, "power"],
      [-1, "home"], //Register
      [-1, "refresh"], //Register

      [142, "red"],
      [141, "green"],
      [140, "yellow"],
      [139, "blue"],

      // Numpad
      [7, "numpad", 0],
      [8, "numpad", 1],
      [9, "numpad", 2],
      [10, "numpad", 3],
      [11, "numpad", 4],
      [12, "numpad", 5],
      [13, "numpad", 6],
      [14, "numpad", 7],
      [15, "numpad", 8],
      [16, "numpad", 9],

      // Applications
      [-1, "youtube"],
      [134, "netflix"],
      [-1, "prime"],
      [-1, "spotify"],
      [64, "browser"],
      [-1, "cast"],
      [209, "movies"],
      [-1, "musics"],
      [-1, "usb"],
      [135, "shahid"]
    ]
  }
  async setName(name, adb = false) {
    if (!name) return false

    if (!adb) return playmore.device.setDeviceName(name)
    return __.api.adb.send({
      device: __.device.properties.ip,
      command: "name",
      params: {
        name: name
      }
    })
  }
  async getName() {
    return playmore.device.getDeviceName()
  }
  async getTimeZone() {
    return playmore.device.getTimeZone()
  }
  async setTimeZone(timeZoneId) {
    if (!timeZoneId) return false
    return playmore.device.setTimeZone(timeZoneId)
  }

  /* Register Methods */
  async registerKeys() {
    return true
  }

  /* Volume Management */
  async _resolveNativeVolumeMax() {
    if (typeof this._nativeVolumeMax === "number") return this._nativeVolumeMax

    if (this.deviceClass === "tv") {
      this._nativeVolumeMax = 100
      return this._nativeVolumeMax
    }

    try {
      if (typeof playmore.device.runWithSh === "function") {
        const output = playmore.device.runWithSh("dumpsys audio | grep -A 8 'STREAM_MUSIC:'", true)
        const text = `${output || ""}`
        const match = text.match(/Max:\s*(\d+)/i)
        if (match) {
          const detected = Number(match[1])
          if (Number.isFinite(detected) && detected > 0) {
            this._nativeVolumeMax = detected
            return this._nativeVolumeMax
          }
        }
      }
    } catch (e) {
      // Continue with conservative fallback.
    }

    try {
      const currentNative = Number(playmore.device.volume())
      if (Number.isFinite(currentNative) && currentNative > 15) {
        this._nativeVolumeMax = 100
        return this._nativeVolumeMax
      }
    } catch (e) {
      // Continue with conservative fallback.
    }

    // Most Android STB builds expose media stream as 0..15.
    this._nativeVolumeMax = 15
    return this._nativeVolumeMax
  }
  async volume(volume) {
    const nativeMax = await this._resolveNativeVolumeMax()
    if (typeof volume !== "number") {
      const level = playmore.device.volume()
      let percent = Math.round((level * 100) / nativeMax)
      // Self-heal wrong max detection (e.g. native level reaches 100 while max assumed 15).
      if (percent > 100 && level > nativeMax) {
        this._nativeVolumeMax = 100
        percent = Math.round((level * 100) / this._nativeVolumeMax)
      }
      return percent
    } else {
      return playmore.device.volume(Math.round((nativeMax * volume) / 100))
    }
  }
  async mute(value) {
    if (["boolean", "number"].indexOf(typeof value) >= 0) return playmore.device.mute(_$.true(value))
    return playmore.device.mute()
  }
  async getVolumeProfile() {
    return this.deviceClass === "stb" ? "stb" : "tv"
  }
  async maxVolume() {
    _$.vue.$on("volumeChanged", event => {
      if (event.detail > __.device.maxVolume) __.device.volume(__.device.maxVolume)
    })
    return true
  }

  /* Power Management */
  async getPowerState() {
    return "on"
  }
  async powerOn() {
    return true
  }
  async standBy() {
    return true
  }
  async reboot() {
    playmore.platform.setConfig("rebootByDevice", true)
    setTimeout(() => playmore.device.reboot(), 2000)
    return true
  }
  async clearData() {
    const promise = await _$.progress.create()

    /* Library Code */
    playmore.platform.returnToPlatform()
    await _$.sleep(1500)
    playmore.device.clearAppData()
    /* Library Code */

    _$.sleep(3000).then(() => promise.resolve())

    return promise.done
  }

  /* Soft AP */
  async getSoftAP() {
    const { password, ssid, status } = JSON.parse(playmore.device.getSoftAP())

    return {
      ssid: ssid,
      password: password,
      status: _$.true(status)
    }
  }
  async enableSoftAP() {
    playmore.device.enableSoftAP()
    await _$.sleep(1000)
    return true
  }
  async disableSoftAP() {
    playmore.device.disableSoftAP()
    await _$.sleep(1000)
    return true
  }
  async isSoftAPEnabled() {
    return playmore.device.isEnabledSoftAP()
  }
  _checkRemoteState() {
    const oval = _$.store.getItem("remoteState"),
      oval_ = JSON.stringify(oval)

    const nval = this._getRemoteState(),
      nval_ = JSON.stringify(nval)

    if (oval_ === nval_) return

    _$.store.setItem("remoteState", nval)
    const locationNumber = __.device.get("location")

    axios()
      .post("/api/send/remoteState", { mac: __.device.properties.mac, location: locationNumber, state: nval_ })
      .catch(err => _$.error(err))

    return true
  }
  _getRemoteState() {
    try {
      const device = JSON.parse(playmore.device.getBluetoothDevices())
        .devices.filter(item => item.name === "RemoteG10")
        .pop()

      const { connected: status, batteryLevel: battery } = device

      return { status, battery }
    } catch (error) {
      return { status: false, battery: 0 }
    }
  }
}

export default Device
